import { BasketToggle } from 'components/basket';
import { FilterOutlined, FormOutlined, PhoneOutlined } from '@ant-design/icons';
import logo from 'images/logo-full.png';
import PropType from 'prop-types';
import * as ROUTE from 'constants/routes';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Badge from './Badge';
import FiltersToggle from './FiltersToggle';

const Navigation = (props) => {
  const {
    isAuthenticating, basketLength, disabledPaths
  } = props;
  const { pathname } = useLocation();

  const onClickLink = (e) => {
    if (isAuthenticating) e.preventDefault();
  };

  return (
    <nav className="mobile-navigation">
      <div className="mobile-navigation-main">
        <div className="logo">
          <Link onClick={onClickLink} to="/">
            <img alt="Logo" src={logo} />
          </Link>
        </div>
        <div className="mobile-navigation-sec">
          {pathname === ROUTE.SHOP && (
            <FiltersToggle>
              <FilterOutlined style={{ fontSize: '2.4rem' }} />
            </FiltersToggle>
          )}
          <BasketToggle>
            {({ onClickToggle }) => (
              <button
                className="button-link navigation-menu-link basket-toggle"
                onClick={onClickToggle}
                disabled={disabledPaths.includes(pathname)}
                type="button"
              >
                <Badge count={basketLength}>
                  <FormOutlined style={{ fontSize: '2.4rem' }} />
                </Badge>
              </button>
            )}
          </BasketToggle>
          <a href="tel: +91 96263 41341">
            <PhoneOutlined style={{ fontSize: '2.4rem' }} />
          </a>
        </div>
      </div>
    </nav>
  );
};

Navigation.propTypes = {
  isAuthenticating: PropType.bool.isRequired,
  basketLength: PropType.number.isRequired,
  disabledPaths: PropType.arrayOf(PropType.string).isRequired
  // eslint-disable-next-line react/require-default-props
};

export default Navigation;
